module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("THE HISTORY OF DISABILITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A series edited by Paul K. Longmore and Lauri Umansky")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("The New Disability History: American Perspectives")]), _c('br'), _vm._v("Edited by Paul K. Longmore and Lauri Umansky")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Reflections: The Life and Writings of a Young Blind Woman")]), _c('br'), _c('em', [_vm._v("in Post-Revolutionary France")]), _c('br'), _vm._v("Thérèse-Adèle Husson"), _c('br'), _vm._v("Edited and translated by"), _c('br'), _vm._v("Catherine J. Kudlick and Zina Weygand")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Signs of Resistance: American Deaf Cultural History,"), _c('br'), _vm._v("1900 to World War II")]), _c('br'), _vm._v("Susan Burch")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("The Radical Lives of Helen Keller")]), _c('br'), _vm._v("Kim E. Nielsen")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Mental Retardation in America: A Historical Reader")]), _c('br'), _vm._v("Edited by Steven Noll and James W. Trent, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Helen Keller: Selected Writings")]), _c('br'), _vm._v("Edited by Kim E. Nielsen")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47714b11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 60
// module chunks = 0